import {
  Box,
  Grid2,
  InputAdornment,
  Paper,
  TextField,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormStyles } from "../../../hooks";
import { DepthMeasurementPreview } from "../../../types/interfaces/file/imports/depthMeasurements";
import { formatTimestamp } from "../../../utils";

interface UploadDepthMeasurementFormProps {
  depthMeasurement: DepthMeasurementPreview;
  variableName: string;
  variableUnit: string;
}

export const UploadDepthMeasurementForm = ({
  depthMeasurement,
  variableName,
  variableUnit,
}: UploadDepthMeasurementFormProps) => {
  const { t } = useTranslation();
  const formStyles = useFormStyles(true);

  return (
    <Box>
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" mb={2}>
              {t("captures.capture.depth-measurement.title")}
            </Typography>
            <Grid2 container spacing={2}>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.depth-measurement.measured-at")}
                  value={depthMeasurement.measuredAt ? formatTimestamp(depthMeasurement.measuredAt) : ""}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.depth-measurement.start-depth")}
                  value={depthMeasurement.startDepth}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.depth-measurement.end-depth")}
                  value={depthMeasurement.endDepth}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.depth-measurement.variable")}
                  value={variableName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.depth-measurement.value")}
                  value={depthMeasurement.value}
                  disabled
                  sx={{ ...formStyles }}
                  slotProps={{
                    input: {
                      startAdornment: depthMeasurement.flag
                        ? <InputAdornment position="start">{depthMeasurement.flag}</InputAdornment>
                        : undefined,
                      endAdornment: <InputAdornment position="end">{variableUnit}</InputAdornment>
                    },
                  }}
                />
              </Grid2>
            </Grid2>
          </Paper>
        </Grid2>
      </Grid2>
    </Box>
  );
};